import { FC } from 'react';
import { render } from 'react-dom';
import { Store } from 'redux';
import { Provider } from 'react-redux';
import { Environment, ReactRelayContext } from 'react-relay/legacy';
import { IntlProvider } from 'dibs-react-intl';
import serverVars from 'server-vars';
import { actionCreators } from '../actions';

const getBuyerFooterClient = async ({
    store,
    relayEnv,
}: {
    store: Store;
    relayEnv: Environment;
}): Promise<{
    updateUserState: () => void;
}> => {
    const locale = serverVars.get('locale');
    const messages = serverVars.get('messages');

    const isMobile: boolean = serverVars.get('settings.isMobile');

    const Wrapper: FC = ({ children }) => {
        return (
            <IntlProvider locale={locale} defaultLocale="en" messages={messages}>
                <ReactRelayContext.Provider
                    value={{
                        environment: relayEnv,
                    }}
                >
                    <Provider store={store}>{children}</Provider>
                </ReactRelayContext.Provider>
            </IntlProvider>
        );
    };

    if (isMobile) {
        const navPromise = await import(
            /* webpackChunkName: "mobileFooter" */ '../components/mobileFooter'
        );

        const messageBannerPromise = import(
            /* webpackChunkName: "MobileFooterMessageBanner" */ '../components/MessageBanner/MobileFooterMessageBanner'
        );

        const [nav, { default: MobileFooterMessageBanner }] = await Promise.all([
            navPromise,
            messageBannerPromise,
        ]);

        const node = document.getElementById('js-footer');
        if (node) {
            const div = document.createElement('div');
            div.className = 'footer-message-banner';
            node.parentNode?.insertBefore(div, node.nextSibling);
            render(
                <Wrapper>
                    <MobileFooterMessageBanner environment={relayEnv} />
                </Wrapper>,
                div
            );
        }

        await nav.render({ relayEnv, Wrapper });
    } else {
        const nav = await import(
            /* webpackChunkName: "responsiveFooter" */ '../components/responsiveFooter'
        );

        await nav.render({ relayEnv, Wrapper });
    }

    return {
        updateUserState: store.dispatch.bind(null, actionCreators.setUpdateUserState(true)),
    };
};

export { getBuyerFooterClient };
